import { render } from "./ChangePasswordPage.vue?vue&type=template&id=76dc8493&scoped=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js"

import "./ChangePasswordPage.vue?vue&type=style&index=0&id=76dc8493&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76dc8493"]])

export default __exports__